export const getSupplementVideos = (videos) => {
  return (videos || []).filter((eachVideo) => eachVideo.type.match(/SUPPLEMENT/ig));
};